/* eslint-disable @typescript-eslint/no-unused-vars */
import { Paginated } from "@/@types/paginated";
import { apiSlice } from "./http";
import { ITaxHistory, ITaxHistoryParams } from "@/@types/tax-history";
import { Tags } from "@/enum/tags";

export const TaxHistory = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTaxHistory: builder.query<Paginated<ITaxHistory>, ITaxHistoryParams>({
      query: ({ meta, search, type, tax_type_request, created_at }) => {
        const paramsObj = {
          search,
          type,
          tax_type_request,
          created_at,
          page: meta.page?.toString(),
          perPage: meta.perPage?.toString(),
        };

        const params = new URLSearchParams(
          Object.entries(paramsObj)
            .filter(([_, value]) => value !== undefined)
            .reduce(
              (acc, [key, value]) => ({ ...acc, [key]: value as string }),
              {}
            )
        );

        return {
          url: `/tax-history/find-by-tax-history?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.TAX_HISTORY],
    }),
  }),
  overrideExisting: true,
});

export const { useGetTaxHistoryQuery } = TaxHistory;

export const {
  endpoints: {
    getTaxHistory: { select: selectTaxHistory },
  },
} = TaxHistory;
